import type { FlexConstraintRange } from "src/hooks/usePanelResize/usePanelResize.types";
import type { ToolboxConfig } from "./AppToolboxSlot.types";

// initial flex values per-panel
export const INITIAL_FLEX_VALUES: [number, number] = [3, 1];

// flex values range limits, per panel
export const TOOLBOX_RESIZE_RANGE: FlexConstraintRange = {
  min: "350px", // both left & right panels must be at least 350px wide
};

export const AI_TOOLBOX_SECTION_VALUE = "ai" as const;
export const TOOLBOX_SEARCH_PARAM = "toolbox";

export const DEFAULT_TOOLBOX_CONFIG: ToolboxConfig = {
  key: "",
  sections: [],
};
